/**
 * koda-datasheet.js
 * Product Data Sheet PDF generator — reads config from window.KodaDatasheetConfig
 */

/* global getBase64ImageFromURL */

document.addEventListener("DOMContentLoaded", function () {
  const pdfButton = document.getElementById("ExportToPdfButton");
  if (!pdfButton) return;

  const loadJostFonts = async (doc) => {
    const getFontUrl = (weight) => {
      for (const sheet of document.styleSheets) {
        try {
          for (const rule of sheet.cssRules || []) {
            if (rule.type !== CSSRule.FONT_FACE_RULE) continue;
            const family = (rule.style.fontFamily || "").replace(/["']/g, "").trim();
            const w = parseInt(rule.style.fontWeight, 10);
            if (family === "Jost" && w === weight) {
              const src = rule.style.getPropertyValue("src") || "";
              // Prefer TTF — jsPDF cannot handle woff/woff2 formats
              const ttfMatch = src.match(/url\(["']?([^"')]+\.ttf[^"')]*?)["']?\)/i);
              if (ttfMatch) return ttfMatch[1];
              // Fall back to any URL only if it is NOT woff/woff2
              const anyMatch = src.match(/url\(["']?([^"')]+)["']?\)/);
              if (anyMatch && /\.(woff2?|eot)(\?|$)/i.test(anyMatch[1])) return null;
              return anyMatch ? anyMatch[1] : null;
            }
          }
        } catch (_) {}
      }
      return null;
    };
    const toBase64 = async (url) => {
      const buf = await (await fetch(url)).arrayBuffer();
      const bytes = new Uint8Array(buf);
      let bin = "";
      for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
      return btoa(bin);
    };
    try {
      const rUrl = getFontUrl(400), bUrl = getFontUrl(700);
      // If no TTF URLs were found, skip registration and use the built-in font
      if (!rUrl && !bUrl) return "helvetica";
      if (rUrl) { doc.addFileToVFS("Jost-Regular.ttf", await toBase64(rUrl)); doc.addFont("Jost-Regular.ttf", "Jost", "normal"); }
      if (bUrl) { doc.addFileToVFS("Jost-Bold.ttf",    await toBase64(bUrl)); doc.addFont("Jost-Bold.ttf",    "Jost", "bold"); }
      return "Jost";
    } catch (_) { return "helvetica"; }
  };

  const _decodeEl = document.createElement("textarea");
  const cleanText = (str) => {
    if (!str) return "";
    _decodeEl.innerHTML = str;
    
    return _decodeEl.value
      .replace(/[\u2000-\u200A\u202F\u205F\u3000]/g, " ")
      .replace(/[\u0000-\u0008\u000B-\u000C\u000E-\u001F\u007F-\u009F\u200B-\u200F\u2028-\u202F\u2060-\u206F\uFEFF\u00AD]/g, "")
      .trim();
  };

  pdfButton.addEventListener("click", async function () {
    const cfg = window.KodaDatasheetConfig || {};
    const originalText = pdfButton.innerText;
    pdfButton.innerText = "Generating Data Sheet...";
    pdfButton.disabled = true;

    try {
      const { jsPDF } = window.jspdf;
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const fontName = await loadJostFonts(doc);

      // ── Layout config ──────────────────────────────────────────────────────────
      const margin = 15;
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const textWidth = pageWidth - margin * 2;
      const maxColY = pageHeight - 30;
      const swatchSz = 7;
      const varRowH = 9;

      // ── HEADER ─────────────────────────────────────────────────────────────────
      const logoImg = document.querySelector(".header__heading-logo");
      const base64Logo = await getBase64ImageFromURL(
        logoImg ? logoImg.src : null,
      );
      let headerBottomY = 10;

      if (base64Logo) {
        const lp = doc.getImageProperties(base64Logo);
        let logoW = 45,
          logoH = (lp.height * logoW) / lp.width;
        if (logoH > 20) {
          logoH = 20;
          logoW = (lp.width * logoH) / lp.height;
        }
        const logoX = (pageWidth - logoW) / 2;
        doc.addImage(
          base64Logo,
          "PNG",
          logoX,
          8,
          logoW,
          logoH,
          undefined,
          "FAST",
        );
        headerBottomY = 8 + logoH + 5;
      } else {
        doc.setFontSize(16);
        doc.setFont(fontName, "normal");
        doc.setTextColor(0, 0, 0);
        doc.text(cfg.shopName || "", pageWidth / 2, 14, { align: "center" });
        headerBottomY = 20;
      }

      doc.setFontSize(11);
      doc.setFont(fontName, "bold");
      doc.setTextColor(0, 0, 0);
      doc.text("Product Datasheet", margin, headerBottomY);
      const lineY = headerBottomY + 4;
      doc.setLineWidth(0.5);
      doc.line(margin, lineY, pageWidth - margin, lineY);

      // ── TITLE / SKU table ──────────────────────────────────────────────────────
      const rawTitle = (cfg.productTitle || "")
        .replace(/&amp;/g, "&")
        .replace(/&#39;/g, "'");
      const rawSku = cfg.productSku || "";
      const rawHandle = cfg.productHandle || "";

      const tableY = lineY + 6;
      const col1Pct = 0.65;
      const col1W = textWidth * col1Pct;
      const col2W = textWidth * (1 - col1Pct);
      const cellPadX = 4,
        cellPadY = 4,
        minRowH = 12;

      doc.setFontSize(13);
      doc.setFont(fontName, "bold");
      const titleLines = doc.splitTextToSize(rawTitle, col1W - cellPadX * 2);
      const lineHTitle = doc.getFontSize() * 0.352778 * 1.35;
      const rowH = Math.max(
        minRowH,
        titleLines.length * lineHTitle + cellPadY * 2,
      );

      doc.setFillColor(245, 245, 245);
      doc.rect(margin, tableY, col1W, rowH, "F");
      doc.setFillColor(255, 255, 255);
      doc.rect(margin + col1W, tableY, col2W, rowH, "F");
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.3);
      doc.rect(margin, tableY, textWidth, rowH, "S");
      doc.line(margin + col1W, tableY, margin + col1W, tableY + rowH);

      doc.setFontSize(13);
      doc.setFont(fontName, "bold");
      doc.setTextColor(20, 20, 20);
      doc.text(
        titleLines,
        margin + cellPadX,
        tableY + cellPadY + lineHTitle * 0.8,
      );

      const skuLabel = rawSku || rawHandle || "—";
      doc.setFontSize(9);
      doc.setFont(fontName, "normal");
      doc.setTextColor(100, 100, 100);
      const skuLines = doc.splitTextToSize(skuLabel, col2W - cellPadX * 2);
      const skuLineH = doc.getFontSize() * 0.352778 * 1.35;
      const skuY =
        tableY + (rowH - skuLines.length * skuLineH) / 2 + skuLineH * 0.8;
      doc.text(skuLines, margin + col1W + col2W - cellPadX, skuY, {
        align: "right",
      });

      let yOffset = tableY + rowH + 6;

      // ── DESCRIPTION ────────────────────────────────────────────────────────────
      const descEl = document.getElementById("descriptionContent");
      const descText = descEl ? descEl.innerText.trim() : "";
      if (descText) {
        doc.setFontSize(9);
        doc.setFont(fontName, "normal");
        doc.setTextColor(70, 70, 70);
        const splitDesc = doc.splitTextToSize(descText, textWidth);
        doc.text(splitDesc, margin, yOffset);
        yOffset += splitDesc.length * 4 + 10;
      } else {
        yOffset += 5;
      }

      // ── SPEC IMAGE (col izquierda) ──────────────────────────────────────────────
      const specImgEl = document.querySelector(".custom-specifications-image");
      const imgUrl = specImgEl ? specImgEl.src : cfg.productFeaturedImage || "";
      const base64Img = await getBase64ImageFromURL(imgUrl);
      if (base64Img) {
        const sp = doc.getImageProperties(base64Img);
        let sW = 80, sH = (sp.height * sW) / sp.width;
        if (sH > 80) { sH = 80; sW = (sp.width * sH) / sp.height; }
        doc.addImage(base64Img, "PNG", margin, yOffset, sW, sH, undefined, "FAST");
      }

      // ── VARIANTS ─────────────────────────────────────────────────────────────
      const mainProductEl =
        document.getElementById("MainProduct-" + cfg.sectionId) || document;
      const allFieldsetsRaw = Array.from(
        mainProductEl.querySelectorAll(".product-form__input"),
      );
      const allFieldsets = allFieldsetsRaw
        .filter(
          (el) =>
            !el.classList.contains("product-form__input--quantity") &&
            !el.classList.contains("product-form__quantity") &&
            !el.querySelector(".custom-variant-option") &&
            (el.querySelector("legend") || el.querySelector("label.form__label")),
        )

        .filter((el, _idx, arr) => {
          const lbl = el.querySelector("legend") || el.querySelector("label.form__label");
          const name = lbl ? lbl.innerText.replace(/:.*/, "").trim().toLowerCase() : null;
          if (!name) return true;
          return arr.findIndex((other) => {
            const o = other.querySelector("legend") || other.querySelector("label.form__label");
            return o && o.innerText.replace(/:.*/, "").trim().toLowerCase() === name;
          }) === _idx;
        });

      const colourFieldsets = allFieldsets.filter(
        (fs) => !!fs.querySelector(".variant-button[data-swatch-value]"),
      );
      const nonColourFieldsets = allFieldsets.filter(
        (fs) => !fs.querySelector(".variant-button[data-swatch-value]"),
      );

      const metaColorImgs = Array.from(
        document.querySelectorAll(".metacolor-image"),
      );
      const hasMetaColors = metaColorImgs.length > 0;

      const renderMetaColors = async (colX, colW, getY, setY) => {
        const lineH = 4;
        const pageBreak = (needed) => {
          if (getY() + needed > maxColY) {
            doc.addPage();
            setY(20);
          }
        };

        setY(getY() + 4);
        pageBreak(8);
        doc.setFontSize(9);
        doc.setFont(fontName, "bold");
        doc.setTextColor(0, 0, 0);
        doc.text("Colour", colX, getY());
        setY(getY() + 5);

        const firstY = getY();

        for (const imgEl of metaColorImgs) {
          const tip =
            imgEl.parentElement &&
            imgEl.parentElement.querySelector(".tooltip-color")
              ? imgEl.parentElement.querySelector(".tooltip-color")
              : imgEl.nextElementSibling &&
                  imgEl.nextElementSibling.classList.contains("tooltip-color")
                ? imgEl.nextElementSibling
                : document.querySelector(".tooltip-color"); // last-resort
          const name = tip ? tip.innerText.trim() : "";
          const availW = colW - swatchSz - 3;
          doc.setFontSize(8);
          doc.setFont(fontName, "normal");
          const nameLines = name ? doc.splitTextToSize(name, availW) : [];
          const itemH = Math.max(swatchSz + 2, nameLines.length * lineH + 2);

          pageBreak(itemH);

          if (getY() > firstY) {
            doc.setDrawColor(210, 210, 210);
            doc.setLineWidth(0.2);
            doc.line(colX, getY() - 1, colX + colW, getY() - 1);
          }

          const b64 = await getBase64ImageFromURL(imgEl.src);
          if (b64)
            doc.addImage(
              b64,
              "PNG",
              colX,
              getY(),
              swatchSz,
              swatchSz,
              undefined,
              "FAST",
            );

          if (nameLines.length > 0) {
            doc.setFontSize(8);
            doc.setFont(fontName, "normal");
            doc.setTextColor(40, 40, 40);
            nameLines.forEach((line, i) =>
              doc.text(line, colX + swatchSz + 3, getY() + lineH + i * lineH),
            );
          }

          setY(getY() + itemH);
        }

        setY(getY() + 3);
      };

      // ── renderFieldset ──────────────────────────────────────────────
      const renderFieldset = async (fs, colX, colW, getY, setY) => {
        const legendEl = fs.querySelector("legend");
        const formLblEl = fs.querySelector("label.form__label");
        const optName =
          legendEl || formLblEl
            ? (legendEl || formLblEl).innerText.replace(/:[\\s\\S]*/, "").trim()
            : "";
        const allLabels = Array.from(fs.querySelectorAll("label[for]")).filter(
          (l) => l !== formLblEl,
        );
        const selectEl = fs.querySelector("select");
        let selectVals = [];
        if (selectEl) {
          const selOpt = selectEl.options[selectEl.selectedIndex];
          const selTxt = selOpt ? selOpt.text.trim() : "";
          if (selTxt && selOpt && selOpt.value !== "") {
            selectVals = [selTxt];
          }
        }

        if (!optName || (allLabels.length === 0 && selectVals.length === 0))
          return;

        const pageBreak = (needed) => {
          if (getY() + needed > maxColY) {
            doc.addPage();
            setY(20);
          }
        };

        setY(getY() + 4);
        pageBreak(8);
        doc.setFontSize(9);
        doc.setFont(fontName, "bold");
        doc.setTextColor(0, 0, 0);
        const isSwatch = fs.querySelector(".variant-button[data-swatch-value]");
        doc.text(isSwatch ? "Colour" : optName, colX, getY());
        setY(getY() + 5);

        const firstY = getY();

        if (allLabels.length > 0) {
          const lineH = 4;

          const swatchItemH = (lbl, maxW) => {
            const hasImg = !!lbl.querySelector(".variant-button__image, img");
            const tip = lbl.querySelector(".tooltip-color");
            const span = lbl.querySelector(".variant-button__text");
            const raw =
              tip || span
                ? (tip || span).innerText.trim()
                : lbl.innerText.trim();
            const txt = raw.split("\n")[0].trim();
            if (!txt) return swatchSz + 2;
            const availW = maxW - (hasImg ? swatchSz + 3 : 0);
            doc.setFontSize(8);
            doc.setFont(fontName, "normal");
            return Math.max(
              swatchSz + 2,
              doc.splitTextToSize(txt, availW).length * lineH + 2,
            );
          };

          const drawSwatchItem = async (lbl, x, y, maxW) => {
            const imgEl = lbl.querySelector(".variant-button__image, img");
            const src = imgEl ? imgEl.src : null;
            if (src) {
              const b64 = await getBase64ImageFromURL(src);
              if (b64)
                doc.addImage(
                  b64,
                  "PNG",
                  x,
                  y,
                  swatchSz,
                  swatchSz,
                  undefined,
                  "FAST",
                );
            }
            const tip = lbl.querySelector(".tooltip-color");
            const span = lbl.querySelector(".variant-button__text");
            const raw =
              tip || span
                ? (tip || span).innerText.trim()
                : lbl.innerText.trim();
            const txt = raw.split("\n")[0].trim();
            if (txt) {
              const tx = src ? x + swatchSz + 3 : x;
              const availW = maxW - (src ? swatchSz + 3 : 0);
              doc.setFontSize(8);
              doc.setFont(fontName, "normal");
              doc.setTextColor(40, 40, 40);
              doc
                .splitTextToSize(txt, availW)
                .forEach((line, i) =>
                  doc.text(line, tx, y + lineH + i * lineH),
                );
            }
          };

          if (isSwatch) {
            const fullW = textWidth;
            const halfW = (fullW - 6) / 2;
            const rX = margin + halfW + 6;
            let tempY = getY(),
              count = 0;
            for (const lbl of allLabels) {
              const h = swatchItemH(lbl, colW);
              if (tempY + h > maxColY) break;
              tempY += h;
              count++;
            }
            const phase1 = allLabels.slice(0, count);
            const phase2 = allLabels.slice(count);

            for (const lbl of phase1) {
              const h = swatchItemH(lbl, colW);
              if (getY() > firstY) {
                doc.setDrawColor(210, 210, 210);
                doc.setLineWidth(0.2);
                doc.line(colX, getY() - 1, colX + colW, getY() - 1);
              }
              await drawSwatchItem(lbl, colX, getY(), colW);
              setY(getY() + h);
            }

            if (phase2.length > 0) {
              doc.addPage();
              let p2Y = 20,
                first = true;
              for (let i = 0; i < phase2.length; i += 2) {
                const lL = phase2[i],
                  lR = phase2[i + 1];
                const hL = swatchItemH(lL, halfW),
                  hR = lR ? swatchItemH(lR, halfW) : 0;
                const pH = Math.max(hL, hR);
                if (!first && p2Y + pH > maxColY) {
                  doc.addPage();
                  p2Y = 20;
                  first = true;
                }
                if (!first) {
                  doc.setDrawColor(210, 210, 210);
                  doc.setLineWidth(0.2);
                  doc.line(margin, p2Y - 1, margin + fullW, p2Y - 1);
                }
                first = false;
                await drawSwatchItem(lL, margin, p2Y, halfW);
                if (lR) await drawSwatchItem(lR, rX, p2Y, halfW);
                p2Y += pH;
              }
              setY(p2Y + 3);
              return;
            }
            setY(getY() + 3);
            return;
          }

          for (const lbl of allLabels) {
            const h = swatchItemH(lbl, colW);
            pageBreak(h);
            if (getY() > firstY) {
              doc.setDrawColor(210, 210, 210);
              doc.setLineWidth(0.2);
              doc.line(colX, getY() - 1, colX + colW, getY() - 1);
            }
            const imgEl = lbl.querySelector(".variant-button__image, img");
            const src = imgEl ? imgEl.src : null;
            if (src) {
              const b64 = await getBase64ImageFromURL(src);
              if (b64)
                doc.addImage(
                  b64,
                  "PNG",
                  colX,
                  getY(),
                  swatchSz,
                  swatchSz,
                  undefined,
                  "FAST",
                );
            }
            const tip = lbl.querySelector(".tooltip-color"),
              span = lbl.querySelector(".variant-button__text");
            const raw =
              tip || span
                ? (tip || span).innerText.trim()
                : lbl.innerText.trim();
            const txt = raw.split("\n")[0].trim();
            if (txt) {
              const tx = src ? colX + swatchSz + 3 : colX;
              const aw = colW - (src ? swatchSz + 3 : 0);
              doc.setFontSize(8);
              doc.setFont(fontName, "normal");
              doc.setTextColor(40, 40, 40);
              doc
                .splitTextToSize(txt, aw)
                .forEach((line, i) =>
                  doc.text(line, tx, getY() + lineH + i * lineH),
                );
            }
            setY(getY() + h);
          }
        } else {
          for (const val of selectVals) {
            pageBreak(varRowH);
            if (getY() > firstY) {
              doc.setDrawColor(210, 210, 210);
              doc.setLineWidth(0.2);
              doc.line(colX, getY() - 1, colX + colW, getY() - 1);
            }
            doc.setFontSize(8);
            doc.setFont(fontName, "normal");
            doc.setTextColor(40, 40, 40);
            doc.text(val, colX, getY() + swatchSz / 2 + 1);
            setY(getY() + varRowH);
          }
        }
        setY(getY() + 3);
      };

      // ── renderTechDetails ──────────────────────────────────────────────────────
      const renderTechDetails = async (techX, colWidth, startY) => {
        let techY = startY;
        const pgBrk = (n) => {
          if (techY + n > maxColY) {
            doc.addPage();
            techY = 20;
          }
        };

        pgBrk(8);
        doc.setFontSize(12);
        doc.setFont(fontName, "bold");
        doc.setTextColor(0, 0, 0);
        doc.text("TECHNICAL DETAILS", techX, techY);
        techY += 7;

        const brandEl = document.querySelector(".target-collection img");
        const b64Brand = await getBase64ImageFromURL(
          brandEl ? brandEl.src : null,
        );
        if (b64Brand) {
          pgBrk(20);
          doc.setFontSize(9);
          doc.setFont(fontName, "bold");
          doc.setTextColor(0, 0, 0);
          doc.text("BRAND", techX, techY);
          techY += 4;
          const bp = doc.getImageProperties(b64Brand);
          let bW = 22,
            bH = (bp.height * bW) / bp.width;
          if (bH > 12) {
            bH = 12;
            bW = (bp.width * bH) / bp.height;
          }
          doc.addImage(
            b64Brand,
            "PNG",
            techX,
            techY,
            bW,
            bH,
            undefined,
            "FAST",
          );
          techY += bH + 5;
        }

        const wrapper = document.querySelector(
          ".custom-specifications-wrapper:not(.is-mobile)",
        );
        const groups = wrapper
          ? wrapper.querySelectorAll(
              ".custom-specifications-details-container .custom-specifications-group",
            )
          : [];
        groups.forEach((group) => {
          const lEl = group.querySelector(".custom-specifications-label");
          const vEls = group.querySelectorAll(
            ".custom-specifications-value-text",
          );
          const lTxt = lEl ? cleanText(lEl.innerText) : "";
          const vTxt = Array.from(vEls)
            .map((e) => cleanText(e.innerText))
            .join(", ");
          if (lTxt.toUpperCase() === "BRAND" || (!lTxt && !vTxt)) return;

          // ── Split text to column width BEFORE rendering ──────────────────
          let sl = [], sv = [];
          if (lTxt) {
            doc.setFontSize(9);
            doc.setFont(fontName, "bold");
            sl = doc.splitTextToSize(lTxt, colWidth);
          }
          if (vTxt) {
            doc.setFontSize(9);
            doc.setFont(fontName, "normal");
            sv = doc.splitTextToSize(vTxt, colWidth);
          }

          // ── Render label — one line at a time with per-line page break ───
          sl.forEach((line) => {
            pgBrk(5);
            doc.setFontSize(9);
            doc.setFont(fontName, "bold");
            doc.setTextColor(0, 0, 0);
            doc.text(line, techX, techY);
            techY += 4;
          });

          // ── Render value — one line at a time with per-line page break ───
          if (sv.length) {
            sv.forEach((line) => {
              pgBrk(5);
              doc.setFontSize(9);
              doc.setFont(fontName, "normal");
              doc.setTextColor(70, 70, 70);
              doc.text(line, techX, techY);
              techY += 4;
            });
            techY += 2; // small gap after the value block
          } else {
            techY += 2;
          }
        });
      };

      // ── renderTechAndFields ────────────────────────────────────────────────────
      const renderTechAndFields = async (startX, totalW, startY) => {
        const gap = 8,
          halfW = Math.floor((totalW - gap) / 2);
        let fsY = startY;
        await renderTechDetails(startX, halfW, startY);
        for (const fs of nonColourFieldsets) {
          await renderFieldset(
            fs,
            startX + halfW + gap,
            halfW,
            () => fsY,
            (v) => {
              fsY = v;
            },
          );
        }
      };

      // ── LAYOUT ────────────────────────────────────────────────────────────────
      const hasRealColour = colourFieldsets.length > 0;

      // Colour swatches (if any) go in the right col of page 1 alongside the spec image
      if (hasRealColour || hasMetaColors) {
        const optX = margin + 95,
          optW = pageWidth - optX - margin;
        let optY = yOffset;

        if (hasRealColour) {
          for (const fs of colourFieldsets) {
            await renderFieldset(
              fs,
              optX,
              optW,
              () => optY,
              (v) => {
                optY = v;
              },
            );
          }
        } else {
          await renderMetaColors(
            optX,
            optW,
            () => optY,
            (v) => {
              optY = v;
            },
          );
        }
      }

      // Always: tech details + non-colour fieldsets on page 2
      doc.addPage();
      await renderTechAndFields(margin, textWidth, 20);

      // ── FOOTER ────────────────────────────────────────────────────────────────
      const totalPages = doc.internal.getNumberOfPages();
      const footerY = pageHeight - 17;
      doc.setFontSize(9);
      doc.setFont(fontName, "normal");
      doc.setTextColor(100, 100, 100);
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.setLineWidth(0.5);
        doc.line(margin, footerY - 4, pageWidth - margin, footerY - 4);
        doc.text(
          "Sydney: 21/198-222 Young Street Waterloo New South Wales 2017 | Phone: 02 9699 6007",
          pageWidth / 2,
          footerY,
          { align: "center" }
        );
        doc.text(
          "Melbourne Lightspace: 2/151 Barkly Avenue, Burnley VIC 3121 | Phone: 03 7064 5130",
          pageWidth / 2,
          footerY + 4,
          { align: "center" }
        );
        doc.text(
          "Email: info@kodalighting.com.au",
          pageWidth / 2,
          footerY + 8,
          { align: "center" }
        );
      }

      doc.save("Data-Sheet-" + (rawSku || "Koda") + ".pdf");
    } catch (err) {
      console.error("Error generating Data Sheet:", err);
      alert("Failed to generate PDF. Please try again.");
    } finally {
      pdfButton.innerText = originalText;
      pdfButton.disabled = false;
    }
  });
});
